import * as React from "react"
import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      "flex h-10 w-full rounded-xl border border-border bg-background px-4 py-2",
      "text-sm placeholder:text-muted-foreground/60 text-foreground",
      "transition-all duration-150",
      "hover:border-blue-300 dark:hover:border-blue-700/60",
      "focus-visible:outline-none focus-visible:border-blue-500 focus-visible:ring-3 focus-visible:ring-blue-500/15",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "[font-size:16px] sm:[font-size:14px]",
      className
    )}
    ref={ref}
    {...props}
  />
))
Input.displayName = "Input"
export { Input }
